/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type userTracking_regionalInfo$ref: FragmentReference;
export type userTracking_regionalInfo = {|
  +incomeLevel: ?{|
    +incomeBracket: ?string,
    +incomePercentile: ?string,
  |},
  +$refType: userTracking_regionalInfo$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "userTracking_regionalInfo",
  "type": "RegionalInfo",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "incomeLevel",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode",
          "type": "String"
        }
      ],
      "concreteType": "IncomeLevel",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomeBracket",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomePercentile",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f02bdb39ee092a2d4baa8aff15f762e3';
module.exports = node;
